module.exports = __webpack_public_path__ + "static/img/loading.cddca549.png";